import axios from "axios";

export const state = {
    booksborrowed: [],
};

export const getters = {
    booksborrowed: state => state.booksborrowed,
};

export const mutations = {
    setBooksBorrowed(state, newValue) {
        state.booksborrowed = newValue
    },
};

export const actions = {
    fetchBooksBorrowed({ commit }) {
        axios.get('/booksborrowed').then(res => {
            commit('setBooksBorrowed', res.data.booksborrowed)
        })
    },
    
    filterBooksBorrowed({commit}, {schoolterm,year}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        let url = "/filterbooksborrowed";
        axios.post(url, formData).then((response) => {
            commit('setBooksBorrowed', response.data.booksborrowed)
        })
    },
};
